import { Text } from '@cinesend/ui-kit'
import { useQuery } from '@tanstack/react-query'
import { statusColors } from '../../../constants/status_colour_map'
import DashboardWidget from '../widget'

const STATUS_ORDER = ['new', 'holdover', 'recalled', 'total', 'expiring']

const DataWidget = ({ cycleID, ...widgetProps }) => {
  const { data: sizes, isLoading, error, refetch } = useQuery([`cycles/`, cycleID, `/get-data-sizes`])

  const items = [...(sizes?.data ?? [])].sort((a, b) => {
    const aIndex = STATUS_ORDER.indexOf(a?.status?.toLowerCase())
    const bIndex = STATUS_ORDER.indexOf(b?.status?.toLowerCase())
    return (aIndex === -1 ? STATUS_ORDER.length : aIndex) - (bIndex === -1 ? STATUS_ORDER.length : bIndex)
  })

  return (
    <DashboardWidget title='Data' isLoading={isLoading} error={error} onRetry={refetch} {...widgetProps}>
      <div className='grid h-full grid-cols-3 gap-3'>
        {items.map((item, index) => {
          const statusKey = item?.status?.toLowerCase()
          const isTotal = statusKey === 'total'
          return (
            <div
              className={`rounded-lg border border-[color:var(--cs-color-border-subtle)] px-3 py-3 ${
                isTotal ? 'col-span-2' : ''
              }`}
              key={`${item.status}-${index}`}
            >
              <Text as='p' variant='md-medium'>
                {item?.size}
              </Text>
              <p className='mt-1 flex items-center gap-2 text-[length:var(--cs-text-sm-font-size)] text-[color:var(--cs-color-foreground-secondary)]'>
                {!isTotal ? (
                  <span
                    className={`h-2 w-2 shrink-0 rounded-full bg-current ${statusColors[statusKey] || 'text-neutral-400'}`}
                    aria-hidden='true'
                  />
                ) : null}
                {item?.status}
              </p>
            </div>
          )
        })}
      </div>
    </DashboardWidget>
  )
}

export default DataWidget
